export default __webpack_public_path__ + "static/media/21cd316eb9e21e2f.d858a67948ae3f0d82411e0e91ee2b3e.svg";